// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27 fill=%27none%27%3E%3Cpath d=%27M4 6l4 4 4-4%27 stroke=%27%2374809a%27 stroke-width=%271.6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════════════
   공통 컴포넌트 — 버튼 · 폼 · 카드 · 배지 · 테이블 · 탭 · 모달 · 토스트
   ══════════════════════════════════════════════════════════════════ */

/* ── 버튼 ───────────────────────────────────────────── */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 20px;
  height: 44px;
  border-radius: var(--r-1);
  font-family: var(--f-b);
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  border: 1px solid transparent;
  white-space: nowrap;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition:
    transform var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease),
    background var(--dur) var(--ease),
    border-color var(--dur) var(--ease),
    color var(--dur) var(--ease);
}

.btn svg {
  width: 16px;
  height: 16px;
  flex: none;
}

.btn:disabled,
.btn[aria-disabled="true"] {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none !important;
}

.btn-p {
  background: var(--brand);
  color: #fff;
  box-shadow: var(--sh-iso-brand);
}

.btn-p:hover:not(:disabled) {
  background: var(--brand);
  transform: translate(-2px, -2px);
  box-shadow: var(--sh-iso-brand-hover);
}

.btn-p:active:not(:disabled) {
  transform: translate(1px, 1px);
  box-shadow: 2px 2px 0 var(--brand-deep);
}

.btn-s {
  background: var(--surface);
  color: var(--ink);
  border-color: var(--line-strong);
  box-shadow: var(--sh-iso);
}

.btn-s:hover:not(:disabled) {
  transform: translate(-2px, -2px);
  box-shadow: var(--sh-iso-hover);
  border-color: var(--ink-3);
}

.btn-s:active:not(:disabled) {
  transform: translate(1px, 1px);
  box-shadow: 2px 2px 0 var(--line);
}

.btn-g {
  background: transparent;
  color: var(--ink-2);
}

.btn-g:hover:not(:disabled) {
  background: var(--surface-3);
  color: var(--ink);
}

.btn-soft {
  background: var(--brand-soft);
  color: var(--brand-deep);
}

.btn-soft:hover:not(:disabled) {
  background: var(--brand-soft-2);
}

.btn-d {
  background: var(--err-soft);
  color: var(--err);
}

.btn-d:hover:not(:disabled) {
  background: #fadcd9;
}

.btn-spark {
  background: var(--spark);
  color: var(--ink);
  box-shadow: 6px 6px 0 var(--spark-deep);
}

.btn-spark:hover:not(:disabled) {
  transform: translate(-2px, -2px);
  box-shadow: 9px 9px 0 var(--spark-deep);
}

.btn-sm {
  height: 34px;
  padding: 0 14px;
  font-size: 13px;
  border-radius: 5px;
}

.btn-sm.btn-p { box-shadow: 4px 4px 0 var(--brand-deep); }
.btn-sm.btn-s { box-shadow: 4px 4px 0 var(--line); }
.btn-sm.btn-p:hover:not(:disabled) { box-shadow: 6px 6px 0 var(--brand-deep); }
.btn-sm.btn-s:hover:not(:disabled) { box-shadow: 6px 6px 0 var(--line); }

.btn-lg {
  height: 52px;
  padding: 0 28px;
  font-size: 15px;
}

.btn-block {
  width: 100%;
}

.btn-icon {
  width: 38px;
  height: 38px;
  padding: 0;
  border-radius: var(--r-1);
  color: var(--ink-2);
  border: 1px solid var(--line);
  background: var(--surface);
}

.btn-icon:hover:not(:disabled) {
  color: var(--brand);
  border-color: var(--brand-soft-2);
  background: var(--brand-soft);
}

.btn-icon svg {
  width: 17px;
  height: 17px;
}

.btn-link {
  color: var(--brand);
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  height: auto;
}

.btn-link:hover {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.btn-link svg {
  width: 15px;
  height: 15px;
  transition: transform var(--dur) var(--ease);
}

.btn-link:hover svg {
  transform: translateX(3px);
}

/* 스피너 */
.spin {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-right-color: transparent;
  animation: spin 0.7s linear infinite;
  flex: none;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ── 폼 ─────────────────────────────────────────────── */
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.field > label,
.field .label {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink-2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.field .label .req {
  color: var(--spark);
  margin-left: 2px;
}

.field .hint {
  font-size: 12px;
  color: var(--ink-3);
}

.field .error {
  font-size: 12px;
  color: var(--err);
  display: flex;
  align-items: center;
  gap: 5px;
}

.input,
.select,
.textarea {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 44px;
  padding: 0 14px;
  border: 1px solid var(--line);
  border-radius: var(--r-1);
  background: var(--surface);
  color: var(--ink);
  font-size: 14.5px;
  transition: border-color var(--dur), box-shadow var(--dur), background var(--dur);
  outline: none;
  appearance: none;
  -webkit-appearance: none;
}

.input::placeholder,
.textarea::placeholder {
  color: var(--ink-4);
}

.input:hover,
.select:hover,
.textarea:hover {
  border-color: var(--line-strong);
}

.input:focus,
.select:focus,
.textarea:focus {
  border-color: var(--brand);
  box-shadow: 0 0 0 3px var(--brand-soft);
}

.input:disabled,
.select:disabled,
.textarea:disabled,
.input[readonly] {
  background: var(--surface-2);
  color: var(--ink-3);
}

.textarea {
  height: auto;
  min-height: 120px;
  padding: 12px 14px;
  line-height: 1.55;
  resize: vertical;
}

.select {
  padding-right: 38px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  cursor: pointer;
}

.field.has-error .input,
.field.has-error .select,
.field.has-error .textarea {
  border-color: var(--err);
}

.field.has-error .input:focus,
.field.has-error .textarea:focus {
  box-shadow: 0 0 0 3px var(--err-soft);
}

.input-sm {
  height: 36px;
  font-size: 13.5px;
  padding: 0 12px;
}

/* 아이콘이 붙은 입력 */
.input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.input-wrap > .input {
  padding-left: 40px;
}

.input-wrap > .ico {
  position: absolute;
  left: 13px;
  width: 17px;
  height: 17px;
  color: var(--ink-3);
  pointer-events: none;
}

.input-wrap > .ico svg {
  width: 100%;
  height: 100%;
}

.input-wrap > .trail {
  position: absolute;
  right: 6px;
  height: 32px;
  padding: 0 10px;
  border-radius: 5px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--ink-3);
}

.input-wrap > .trail:hover {
  color: var(--ink);
  background: var(--surface-3);
}

.input-wrap.has-trail > .input {
  padding-right: 64px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 20px;
}

.form-grid .span-2 {
  grid-column: span 2;
}

@media (max-width: 640px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  .form-grid .span-2 {
    grid-column: span 1;
  }
}

/* 체크박스 */
.check {
  display: inline-flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  font-size: 13.5px;
  color: var(--ink-2);
  line-height: 1.5;
  -webkit-user-select: none;
          user-select: none;
}

.check input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.check .box {
  width: 18px;
  height: 18px;
  flex: none;
  margin-top: 1px;
  border-radius: 4px;
  border: 1.5px solid var(--line-strong);
  background: var(--surface);
  display: grid;
  place-items: center;
  transition: all var(--dur);
}

.check .box svg {
  width: 11px;
  height: 11px;
  opacity: 0;
  transform: scale(0.6);
  transition: all var(--dur);
  color: #fff;
}

.check input:checked ~ .box {
  background: var(--brand);
  border-color: var(--brand);
}

.check input:checked ~ .box svg {
  opacity: 1;
  transform: scale(1);
}

.check input:focus-visible ~ .box {
  box-shadow: 0 0 0 3px var(--brand-soft);
}

.check.has-error .box {
  border-color: var(--err);
}

/* 세그먼트/라디오 칩 */
.seg {
  display: inline-flex;
  padding: 4px;
  background: var(--surface-3);
  border-radius: var(--r-2);
  gap: 2px;
}

.seg button {
  height: 34px;
  padding: 0 14px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ink-3);
  transition: all var(--dur);
}

.seg button:hover {
  color: var(--ink);
}

.seg button.is-on {
  background: var(--surface);
  color: var(--ink);
  box-shadow: var(--sh-1);
}

/* ── 카드 ───────────────────────────────────────────── */
.card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-3);
  padding: 22px;
}

.card--iso {
  box-shadow: var(--sh-iso);
  border-radius: var(--r-2);
}

.card--soft {
  background: var(--surface-2);
  border-color: var(--line-2);
}

.card--pad-lg {
  padding: 28px;
}

.card-title {
  font-family: var(--f-d);
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.015em;
}

.card-sub {
  font-size: 13.5px;
  color: var(--ink-3);
  margin-top: 4px;
}

.card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

/* ── 배지 ───────────────────────────────────────────── */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 9px;
  border-radius: var(--r-pill);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  white-space: nowrap;
  background: var(--mute-soft);
  color: var(--ink-2);
  line-height: 1;
}

.badge .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.badge--mono {
  font-family: var(--f-m);
  font-size: 11px;
  letter-spacing: 0.04em;
  border-radius: 4px;
}

.badge--ok { background: var(--ok-soft); color: var(--ok); }
.badge--warn { background: var(--warn-soft); color: var(--warn); }
.badge--err { background: var(--err-soft); color: var(--err); }
.badge--info { background: var(--info-soft); color: var(--info); }
.badge--brand { background: var(--brand-soft); color: var(--brand-deep); }
.badge--spark { background: var(--spark-soft); color: var(--spark-text); }
.badge--dark { background: var(--ink); color: #fff; }
.badge--outline {
  background: transparent;
  border: 1px solid var(--line);
  color: var(--ink-2);
}

/* 상태 → 배지 매핑 */
.badge[data-status="PENDING"],
.badge[data-status="DRAFT"] { background: var(--mute-soft); color: var(--ink-2); }
.badge[data-status="SUBMITTED"],
.badge[data-status="CONFIRMED"] { background: var(--info-soft); color: var(--info); }
.badge[data-status="REVIEWED"],
.badge[data-status="IN_PRODUCTION"] { background: var(--brand-soft); color: var(--brand-deep); }
.badge[data-status="SHIPPED"] { background: var(--warn-soft); color: var(--warn); }
.badge[data-status="DELIVERED"],
.badge[data-status="APPROVED"] { background: var(--ok-soft); color: var(--ok); }
.badge[data-status="CANCELLED"],
.badge[data-status="REJECTED"] { background: var(--err-soft); color: var(--err); }

/* ── 테이블 ─────────────────────────────────────────── */
.tbl-wrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--line);
  border-radius: var(--r-2);
  background: var(--surface);
}

.tbl {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.tbl th,
.tbl td {
  padding: 13px 16px;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid var(--line-2);
  white-space: nowrap;
}

.tbl th {
  font-family: var(--f-m);
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ink-3);
  font-weight: 600;
  background: var(--surface-2);
}

.tbl tbody tr:last-child td {
  border-bottom: 0;
}

.tbl tbody tr:hover td {
  background: var(--surface-2);
}

.tbl tbody tr.is-clickable {
  cursor: pointer;
}

.tbl td.num,
.tbl th.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.tbl .cell-strong {
  font-weight: 600;
  color: var(--ink);
}

.tbl .cell-mono {
  font-family: var(--f-m);
  font-size: 12.5px;
  color: var(--ink-2);
}

/* ── 탭 ─────────────────────────────────────────────── */
.tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid var(--line);
  overflow-x: auto;
  scrollbar-width: none;
}

.tabs::-webkit-scrollbar {
  display: none;
}

.tabs button {
  height: 42px;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ink-3);
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: color var(--dur), border-color var(--dur);
}

.tabs button:hover {
  color: var(--ink);
}

.tabs button.is-on {
  color: var(--brand);
  border-bottom-color: var(--brand);
}

.tabs .count {
  font-family: var(--f-m);
  font-size: 11px;
  padding: 1px 6px;
  border-radius: 4px;
  background: var(--surface-3);
  color: var(--ink-3);
}

.tabs button.is-on .count {
  background: var(--brand-soft);
  color: var(--brand-deep);
}

/* 칩 필터 */
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chip {
  height: 34px;
  padding: 0 14px;
  border-radius: var(--r-pill);
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--ink-2);
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all var(--dur);
}

.chip:hover {
  border-color: var(--line-strong);
  color: var(--ink);
}

.chip.is-on {
  background: var(--ink);
  border-color: var(--ink);
  color: #fff;
}

.chip-sm {
  height: 28px;
  padding: 0 11px;
  font-size: 12px;
}

/* ── 통계 타일 ─────────────────────────────────────── */
.stat {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-2);
  padding: 18px 20px;
  box-shadow: var(--sh-iso);
}

.stat .k {
  font-family: var(--f-m);
  font-size: 11px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink-3);
  font-weight: 600;
}

.stat .v {
  font-family: var(--f-d);
  font-size: 30px;
  font-weight: 800;
  letter-spacing: -0.03em;
  margin-top: 6px;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.stat .v small {
  font-size: 14px;
  font-weight: 600;
  color: var(--ink-3);
  margin-left: 3px;
}

.stat .d {
  font-size: 12.5px;
  color: var(--ink-3);
  margin-top: 8px;
}

/* ── 알림/배너 ─────────────────────────────────────── */
.note {
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  border-radius: var(--r-2);
  font-size: 13.5px;
  line-height: 1.55;
  border: 1px solid transparent;
}

.note svg {
  width: 18px;
  height: 18px;
  flex: none;
  margin-top: 1px;
}

.note b {
  display: block;
  font-weight: 600;
  margin-bottom: 2px;
}

.note--info { background: var(--info-soft); color: var(--info); border-color: #cfe0f7; }
.note--ok { background: var(--ok-soft); color: var(--ok); border-color: #c9ecd4; }
.note--warn { background: var(--warn-soft); color: var(--warn); border-color: #f8dcc2; }
.note--err { background: var(--err-soft); color: var(--err); border-color: #f6cfcb; }
.note--mute { background: var(--surface-2); color: var(--ink-2); border-color: var(--line-2); }

/* ── 빈 상태 ───────────────────────────────────────── */
.empty {
  text-align: center;
  padding: 56px 20px;
  color: var(--ink-3);
}

.empty .art {
  width: 120px;
  height: 100px;
  margin: 0 auto 14px;
}

.empty h4 {
  font-size: 17px;
  font-weight: 700;
  color: var(--ink);
}

.empty p {
  margin-top: 6px;
  font-size: 14px;
  max-width: 40ch;
  margin-left: auto;
  margin-right: auto;
}

.empty .btn {
  margin-top: 18px;
}

/* ── 오류 상태 ─────────────────────────────────────── */
.error-state {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  border: 1px solid #f6cfcb;
  border-radius: var(--r-2);
  background: var(--err-soft);
  color: var(--err);
}

.error-state svg {
  flex: none;
}

.error-state b {
  display: block;
  font-weight: 600;
  color: var(--err);
}

.error-state p {
  font-size: 13px;
  color: var(--ink-2);
  margin-top: 2px;
}

.error-state .btn {
  margin-left: auto;
}

/* ── 스켈레톤 ──────────────────────────────────────── */
.skel {
  background: linear-gradient(90deg, var(--surface-3) 25%, var(--sunk) 37%, var(--surface-3) 63%);
  background-size: 400% 100%;
  animation: skel 1.4s ease infinite;
  border-radius: 6px;
}

@keyframes skel {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

/* ── 페이지네이션 ──────────────────────────────────── */
.pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 18px;
}

.pager .info {
  font-size: 13px;
  color: var(--ink-3);
}

.pager .pages {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pager .pages button {
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ink-2);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all var(--dur);
}

.pager .pages button:hover:not(:disabled) {
  background: var(--surface-3);
  color: var(--ink);
}

.pager .pages button.is-on {
  background: var(--ink);
  color: #fff;
}

.pager .pages button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.pager .pages button svg {
  width: 15px;
  height: 15px;
}

/* ── 모달 ───────────────────────────────────────────── */
.modal-bg {
  position: fixed;
  inset: 0;
  background: rgba(12, 17, 24, 0.55);
  backdrop-filter: blur(3px);
  z-index: var(--z-modal);
  display: grid;
  place-items: center;
  padding: 20px;
  animation: fade 0.18s ease both;
}

.modal {
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 40px);
  background: var(--surface);
  border-radius: var(--r-3);
  box-shadow: var(--sh-3);
  display: flex;
  flex-direction: column;
  animation: rise 0.28s var(--ease-out) both;
  overflow: hidden;
}

.modal--lg {
  max-width: 860px;
}

.modal--sm {
  max-width: 440px;
}

.modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 16px;
  border-bottom: 1px solid var(--line-2);
}

.modal-head h3 {
  font-size: 19px;
  font-weight: 700;
}

.modal-head p {
  color: var(--ink-3);
  font-size: 13.5px;
  margin-top: 3px;
}

.modal-body {
  padding: 20px 24px;
  overflow-y: auto;
}

.modal-foot {
  padding: 14px 24px 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid var(--line-2);
  background: var(--surface-2);
}

/* ── 토스트 ────────────────────────────────────────── */
.toasts {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
}

.toast {
  pointer-events: auto;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 280px;
  max-width: 380px;
  padding: 12px 14px;
  border-radius: var(--r-2);
  background: var(--ink);
  color: #fff;
  box-shadow: var(--sh-3);
  font-size: 13.5px;
  line-height: 1.45;
  animation: rise 0.28s var(--ease-out) both;
}

.toast svg {
  width: 18px;
  height: 18px;
  flex: none;
  margin-top: 1px;
}

.toast--ok svg { color: #5ee08a; }
.toast--err svg { color: #ff8a80; }
.toast--info svg { color: #8fb3ff; }

.toast b {
  display: block;
  font-weight: 600;
}

.toast .x {
  margin-left: auto;
  color: rgba(255, 255, 255, 0.6);
  width: 22px;
  height: 22px;
  border-radius: 4px;
  display: grid;
  place-items: center;
}

.toast .x:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

@media (max-width: 640px) {
  .toasts {
    left: 12px;
    right: 12px;
    bottom: 12px;
  }
  .toast {
    min-width: 0;
    max-width: none;
  }
}

/* ── 타임라인 (주문 상태) ───────────────────────────── */
.timeline {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.timeline .tl {
  display: grid;
  grid-template-columns: 22px 1fr;
  gap: 12px;
  position: relative;
  padding-bottom: 18px;
}

.timeline .tl:last-child {
  padding-bottom: 0;
}

.timeline .tl::before {
  content: "";
  position: absolute;
  left: 10px;
  top: 20px;
  bottom: -2px;
  width: 2px;
  background: var(--line);
}

.timeline .tl:last-child::before {
  display: none;
}

.timeline .tl .pt {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid var(--line-strong);
  background: var(--surface);
  display: grid;
  place-items: center;
  z-index: 1;
}

.timeline .tl .pt svg {
  width: 11px;
  height: 11px;
  color: #fff;
}

.timeline .tl.is-done .pt {
  background: var(--ok);
  border-color: var(--ok);
}

.timeline .tl.is-now .pt {
  background: var(--brand);
  border-color: var(--brand);
  box-shadow: 0 0 0 4px var(--brand-soft);
}

.timeline .tl.is-done::before {
  background: var(--ok);
}

.timeline .tl .t {
  font-weight: 600;
  font-size: 14px;
  color: var(--ink);
}

.timeline .tl .d {
  font-size: 12.5px;
  color: var(--ink-3);
  margin-top: 2px;
}

.timeline .tl:not(.is-done):not(.is-now) .t {
  color: var(--ink-3);
}

/* ── 정의 리스트 (키/값) ────────────────────────────── */
.kv {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 10px 16px;
  font-size: 14px;
}

.kv dt {
  color: var(--ink-3);
  font-size: 13px;
}

.kv dd {
  margin: 0;
  color: var(--ink);
  font-weight: 500;
  min-width: 0;
  overflow-wrap: anywhere;
}

@media (max-width: 480px) {
  .kv {
    grid-template-columns: 1fr;
    gap: 2px 0;
  }
  .kv dd {
    margin-bottom: 8px;
  }
}

/* ── 구분선 ────────────────────────────────────────── */
.hr {
  height: 1px;
  background: var(--line-2);
  border: 0;
  margin: 20px 0;
}

/* ── 아바타 ────────────────────────────────────────── */
.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--brand-soft);
  color: var(--brand-deep);
  font-family: var(--f-d);
  font-weight: 800;
  font-size: 14px;
  display: grid;
  place-items: center;
  overflow: hidden;
  flex: none;
  letter-spacing: 0;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar--lg {
  width: 64px;
  height: 64px;
  font-size: 22px;
}

/* ── antd 오버라이드 (작업 화면 전용) ──────────────── */
.ant-btn-primary {
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components.css"],"names":[],"mappings":"AAAA;;uEAEuE;;AAEvE,wDAAwD;AACxD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB;;;;;gCAK8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,gBAAgB,uCAAuC,EAAE;AACzD,gBAAgB,iCAAiC,EAAE;AACnD,qCAAqC,uCAAuC,EAAE;AAC9E,qCAAqC,iCAAiC,EAAE;;AAExE;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,QAAQ;AACR;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,iFAAiF;EACjF,aAAa;EACb,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;;;;EAIE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yDAA0Q;EAC1Q,4BAA4B;EAC5B,sCAAsC;EACtC,eAAe;AACjB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,SAAS;AACT;EACE,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,wDAAwD;AACxD;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,aAAa,0BAA0B,EAAE,gBAAgB,EAAE;AAC3D,eAAe,4BAA4B,EAAE,kBAAkB,EAAE;AACjE,cAAc,2BAA2B,EAAE,iBAAiB,EAAE;AAC9D,eAAe,4BAA4B,EAAE,kBAAkB,EAAE;AACjE,gBAAgB,6BAA6B,EAAE,wBAAwB,EAAE;AACzE,gBAAgB,6BAA6B,EAAE,wBAAwB,EAAE;AACzE,eAAe,sBAAsB,EAAE,WAAW,EAAE;AACpD;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,eAAe;AACf;8BAC8B,4BAA4B,EAAE,mBAAmB,EAAE;AACjF;kCACkC,4BAA4B,EAAE,kBAAkB,EAAE;AACpF;sCACsC,6BAA6B,EAAE,wBAAwB,EAAE;AAC/F,gCAAgC,4BAA4B,EAAE,kBAAkB,EAAE;AAClF;iCACiC,0BAA0B,EAAE,gBAAgB,EAAE;AAC/E;iCACiC,2BAA2B,EAAE,iBAAiB,EAAE;;AAEjF,uDAAuD;AACvD;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,QAAQ;EACR,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc,4BAA4B,EAAE,kBAAkB,EAAE,qBAAqB,EAAE;AACvF,YAAY,0BAA0B,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACjF,cAAc,4BAA4B,EAAE,kBAAkB,EAAE,qBAAqB,EAAE;AACvF,aAAa,2BAA2B,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AACpF,cAAc,4BAA4B,EAAE,mBAAmB,EAAE,2BAA2B,EAAE;;AAE9F,sDAAsD;AACtD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qDAAqD;AACrD;EACE,+FAA+F;EAC/F,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,KAAK,6BAA6B,EAAE;EACpC,OAAO,0BAA0B,EAAE;AACrC;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA,iBAAiB,cAAc,EAAE;AACjC,kBAAkB,cAAc,EAAE;AAClC,mBAAmB,cAAc,EAAE;;AAEnC;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;AAClB","sourcesContent":["/* ══════════════════════════════════════════════════════════════════\n   공통 컴포넌트 — 버튼 · 폼 · 카드 · 배지 · 테이블 · 탭 · 모달 · 토스트\n   ══════════════════════════════════════════════════════════════════ */\n\n/* ── 버튼 ───────────────────────────────────────────── */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 20px;\n  height: 44px;\n  border-radius: var(--r-1);\n  font-family: var(--f-b);\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  cursor: pointer;\n  user-select: none;\n  transition:\n    transform var(--dur) var(--ease),\n    box-shadow var(--dur) var(--ease),\n    background var(--dur) var(--ease),\n    border-color var(--dur) var(--ease),\n    color var(--dur) var(--ease);\n}\n\n.btn svg {\n  width: 16px;\n  height: 16px;\n  flex: none;\n}\n\n.btn:disabled,\n.btn[aria-disabled=\"true\"] {\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.btn-p {\n  background: var(--brand);\n  color: #fff;\n  box-shadow: var(--sh-iso-brand);\n}\n\n.btn-p:hover:not(:disabled) {\n  background: var(--brand);\n  transform: translate(-2px, -2px);\n  box-shadow: var(--sh-iso-brand-hover);\n}\n\n.btn-p:active:not(:disabled) {\n  transform: translate(1px, 1px);\n  box-shadow: 2px 2px 0 var(--brand-deep);\n}\n\n.btn-s {\n  background: var(--surface);\n  color: var(--ink);\n  border-color: var(--line-strong);\n  box-shadow: var(--sh-iso);\n}\n\n.btn-s:hover:not(:disabled) {\n  transform: translate(-2px, -2px);\n  box-shadow: var(--sh-iso-hover);\n  border-color: var(--ink-3);\n}\n\n.btn-s:active:not(:disabled) {\n  transform: translate(1px, 1px);\n  box-shadow: 2px 2px 0 var(--line);\n}\n\n.btn-g {\n  background: transparent;\n  color: var(--ink-2);\n}\n\n.btn-g:hover:not(:disabled) {\n  background: var(--surface-3);\n  color: var(--ink);\n}\n\n.btn-soft {\n  background: var(--brand-soft);\n  color: var(--brand-deep);\n}\n\n.btn-soft:hover:not(:disabled) {\n  background: var(--brand-soft-2);\n}\n\n.btn-d {\n  background: var(--err-soft);\n  color: var(--err);\n}\n\n.btn-d:hover:not(:disabled) {\n  background: #fadcd9;\n}\n\n.btn-spark {\n  background: var(--spark);\n  color: var(--ink);\n  box-shadow: 6px 6px 0 var(--spark-deep);\n}\n\n.btn-spark:hover:not(:disabled) {\n  transform: translate(-2px, -2px);\n  box-shadow: 9px 9px 0 var(--spark-deep);\n}\n\n.btn-sm {\n  height: 34px;\n  padding: 0 14px;\n  font-size: 13px;\n  border-radius: 5px;\n}\n\n.btn-sm.btn-p { box-shadow: 4px 4px 0 var(--brand-deep); }\n.btn-sm.btn-s { box-shadow: 4px 4px 0 var(--line); }\n.btn-sm.btn-p:hover:not(:disabled) { box-shadow: 6px 6px 0 var(--brand-deep); }\n.btn-sm.btn-s:hover:not(:disabled) { box-shadow: 6px 6px 0 var(--line); }\n\n.btn-lg {\n  height: 52px;\n  padding: 0 28px;\n  font-size: 15px;\n}\n\n.btn-block {\n  width: 100%;\n}\n\n.btn-icon {\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  border-radius: var(--r-1);\n  color: var(--ink-2);\n  border: 1px solid var(--line);\n  background: var(--surface);\n}\n\n.btn-icon:hover:not(:disabled) {\n  color: var(--brand);\n  border-color: var(--brand-soft-2);\n  background: var(--brand-soft);\n}\n\n.btn-icon svg {\n  width: 17px;\n  height: 17px;\n}\n\n.btn-link {\n  color: var(--brand);\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  height: auto;\n}\n\n.btn-link:hover {\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.btn-link svg {\n  width: 15px;\n  height: 15px;\n  transition: transform var(--dur) var(--ease);\n}\n\n.btn-link:hover svg {\n  transform: translateX(3px);\n}\n\n/* 스피너 */\n.spin {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  animation: spin 0.7s linear infinite;\n  flex: none;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── 폼 ─────────────────────────────────────────────── */\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.field > label,\n.field .label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ink-2);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.field .label .req {\n  color: var(--spark);\n  margin-left: 2px;\n}\n\n.field .hint {\n  font-size: 12px;\n  color: var(--ink-3);\n}\n\n.field .error {\n  font-size: 12px;\n  color: var(--err);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.input,\n.select,\n.textarea {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  height: 44px;\n  padding: 0 14px;\n  border: 1px solid var(--line);\n  border-radius: var(--r-1);\n  background: var(--surface);\n  color: var(--ink);\n  font-size: 14.5px;\n  transition: border-color var(--dur), box-shadow var(--dur), background var(--dur);\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\n.input::placeholder,\n.textarea::placeholder {\n  color: var(--ink-4);\n}\n\n.input:hover,\n.select:hover,\n.textarea:hover {\n  border-color: var(--line-strong);\n}\n\n.input:focus,\n.select:focus,\n.textarea:focus {\n  border-color: var(--brand);\n  box-shadow: 0 0 0 3px var(--brand-soft);\n}\n\n.input:disabled,\n.select:disabled,\n.textarea:disabled,\n.input[readonly] {\n  background: var(--surface-2);\n  color: var(--ink-3);\n}\n\n.textarea {\n  height: auto;\n  min-height: 120px;\n  padding: 12px 14px;\n  line-height: 1.55;\n  resize: vertical;\n}\n\n.select {\n  padding-right: 38px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M4 6l4 4 4-4' stroke='%2374809a' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  cursor: pointer;\n}\n\n.field.has-error .input,\n.field.has-error .select,\n.field.has-error .textarea {\n  border-color: var(--err);\n}\n\n.field.has-error .input:focus,\n.field.has-error .textarea:focus {\n  box-shadow: 0 0 0 3px var(--err-soft);\n}\n\n.input-sm {\n  height: 36px;\n  font-size: 13.5px;\n  padding: 0 12px;\n}\n\n/* 아이콘이 붙은 입력 */\n.input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-wrap > .input {\n  padding-left: 40px;\n}\n\n.input-wrap > .ico {\n  position: absolute;\n  left: 13px;\n  width: 17px;\n  height: 17px;\n  color: var(--ink-3);\n  pointer-events: none;\n}\n\n.input-wrap > .ico svg {\n  width: 100%;\n  height: 100%;\n}\n\n.input-wrap > .trail {\n  position: absolute;\n  right: 6px;\n  height: 32px;\n  padding: 0 10px;\n  border-radius: 5px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--ink-3);\n}\n\n.input-wrap > .trail:hover {\n  color: var(--ink);\n  background: var(--surface-3);\n}\n\n.input-wrap.has-trail > .input {\n  padding-right: 64px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 18px 20px;\n}\n\n.form-grid .span-2 {\n  grid-column: span 2;\n}\n\n@media (max-width: 640px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n  .form-grid .span-2 {\n    grid-column: span 1;\n  }\n}\n\n/* 체크박스 */\n.check {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 13.5px;\n  color: var(--ink-2);\n  line-height: 1.5;\n  user-select: none;\n}\n\n.check input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.check .box {\n  width: 18px;\n  height: 18px;\n  flex: none;\n  margin-top: 1px;\n  border-radius: 4px;\n  border: 1.5px solid var(--line-strong);\n  background: var(--surface);\n  display: grid;\n  place-items: center;\n  transition: all var(--dur);\n}\n\n.check .box svg {\n  width: 11px;\n  height: 11px;\n  opacity: 0;\n  transform: scale(0.6);\n  transition: all var(--dur);\n  color: #fff;\n}\n\n.check input:checked ~ .box {\n  background: var(--brand);\n  border-color: var(--brand);\n}\n\n.check input:checked ~ .box svg {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.check input:focus-visible ~ .box {\n  box-shadow: 0 0 0 3px var(--brand-soft);\n}\n\n.check.has-error .box {\n  border-color: var(--err);\n}\n\n/* 세그먼트/라디오 칩 */\n.seg {\n  display: inline-flex;\n  padding: 4px;\n  background: var(--surface-3);\n  border-radius: var(--r-2);\n  gap: 2px;\n}\n\n.seg button {\n  height: 34px;\n  padding: 0 14px;\n  border-radius: 7px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ink-3);\n  transition: all var(--dur);\n}\n\n.seg button:hover {\n  color: var(--ink);\n}\n\n.seg button.is-on {\n  background: var(--surface);\n  color: var(--ink);\n  box-shadow: var(--sh-1);\n}\n\n/* ── 카드 ───────────────────────────────────────────── */\n.card {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-3);\n  padding: 22px;\n}\n\n.card--iso {\n  box-shadow: var(--sh-iso);\n  border-radius: var(--r-2);\n}\n\n.card--soft {\n  background: var(--surface-2);\n  border-color: var(--line-2);\n}\n\n.card--pad-lg {\n  padding: 28px;\n}\n\n.card-title {\n  font-family: var(--f-d);\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: -0.015em;\n}\n\n.card-sub {\n  font-size: 13.5px;\n  color: var(--ink-3);\n  margin-top: 4px;\n}\n\n.card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n}\n\n/* ── 배지 ───────────────────────────────────────────── */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 24px;\n  padding: 0 9px;\n  border-radius: var(--r-pill);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  background: var(--mute-soft);\n  color: var(--ink-2);\n  line-height: 1;\n}\n\n.badge .dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.badge--mono {\n  font-family: var(--f-m);\n  font-size: 11px;\n  letter-spacing: 0.04em;\n  border-radius: 4px;\n}\n\n.badge--ok { background: var(--ok-soft); color: var(--ok); }\n.badge--warn { background: var(--warn-soft); color: var(--warn); }\n.badge--err { background: var(--err-soft); color: var(--err); }\n.badge--info { background: var(--info-soft); color: var(--info); }\n.badge--brand { background: var(--brand-soft); color: var(--brand-deep); }\n.badge--spark { background: var(--spark-soft); color: var(--spark-text); }\n.badge--dark { background: var(--ink); color: #fff; }\n.badge--outline {\n  background: transparent;\n  border: 1px solid var(--line);\n  color: var(--ink-2);\n}\n\n/* 상태 → 배지 매핑 */\n.badge[data-status=\"PENDING\"],\n.badge[data-status=\"DRAFT\"] { background: var(--mute-soft); color: var(--ink-2); }\n.badge[data-status=\"SUBMITTED\"],\n.badge[data-status=\"CONFIRMED\"] { background: var(--info-soft); color: var(--info); }\n.badge[data-status=\"REVIEWED\"],\n.badge[data-status=\"IN_PRODUCTION\"] { background: var(--brand-soft); color: var(--brand-deep); }\n.badge[data-status=\"SHIPPED\"] { background: var(--warn-soft); color: var(--warn); }\n.badge[data-status=\"DELIVERED\"],\n.badge[data-status=\"APPROVED\"] { background: var(--ok-soft); color: var(--ok); }\n.badge[data-status=\"CANCELLED\"],\n.badge[data-status=\"REJECTED\"] { background: var(--err-soft); color: var(--err); }\n\n/* ── 테이블 ─────────────────────────────────────────── */\n.tbl-wrap {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid var(--line);\n  border-radius: var(--r-2);\n  background: var(--surface);\n}\n\n.tbl {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.tbl th,\n.tbl td {\n  padding: 13px 16px;\n  text-align: left;\n  vertical-align: middle;\n  border-bottom: 1px solid var(--line-2);\n  white-space: nowrap;\n}\n\n.tbl th {\n  font-family: var(--f-m);\n  font-size: 11px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n  font-weight: 600;\n  background: var(--surface-2);\n}\n\n.tbl tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.tbl tbody tr:hover td {\n  background: var(--surface-2);\n}\n\n.tbl tbody tr.is-clickable {\n  cursor: pointer;\n}\n\n.tbl td.num,\n.tbl th.num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.tbl .cell-strong {\n  font-weight: 600;\n  color: var(--ink);\n}\n\n.tbl .cell-mono {\n  font-family: var(--f-m);\n  font-size: 12.5px;\n  color: var(--ink-2);\n}\n\n/* ── 탭 ─────────────────────────────────────────────── */\n.tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 1px solid var(--line);\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.tabs button {\n  height: 42px;\n  padding: 0 14px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ink-3);\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: color var(--dur), border-color var(--dur);\n}\n\n.tabs button:hover {\n  color: var(--ink);\n}\n\n.tabs button.is-on {\n  color: var(--brand);\n  border-bottom-color: var(--brand);\n}\n\n.tabs .count {\n  font-family: var(--f-m);\n  font-size: 11px;\n  padding: 1px 6px;\n  border-radius: 4px;\n  background: var(--surface-3);\n  color: var(--ink-3);\n}\n\n.tabs button.is-on .count {\n  background: var(--brand-soft);\n  color: var(--brand-deep);\n}\n\n/* 칩 필터 */\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.chip {\n  height: 34px;\n  padding: 0 14px;\n  border-radius: var(--r-pill);\n  border: 1px solid var(--line);\n  background: var(--surface);\n  color: var(--ink-2);\n  font-size: 13px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: all var(--dur);\n}\n\n.chip:hover {\n  border-color: var(--line-strong);\n  color: var(--ink);\n}\n\n.chip.is-on {\n  background: var(--ink);\n  border-color: var(--ink);\n  color: #fff;\n}\n\n.chip-sm {\n  height: 28px;\n  padding: 0 11px;\n  font-size: 12px;\n}\n\n/* ── 통계 타일 ─────────────────────────────────────── */\n.stat {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-2);\n  padding: 18px 20px;\n  box-shadow: var(--sh-iso);\n}\n\n.stat .k {\n  font-family: var(--f-m);\n  font-size: 11px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n  font-weight: 600;\n}\n\n.stat .v {\n  font-family: var(--f-d);\n  font-size: 30px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  margin-top: 6px;\n  color: var(--ink);\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n}\n\n.stat .v small {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ink-3);\n  margin-left: 3px;\n}\n\n.stat .d {\n  font-size: 12.5px;\n  color: var(--ink-3);\n  margin-top: 8px;\n}\n\n/* ── 알림/배너 ─────────────────────────────────────── */\n.note {\n  display: flex;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: var(--r-2);\n  font-size: 13.5px;\n  line-height: 1.55;\n  border: 1px solid transparent;\n}\n\n.note svg {\n  width: 18px;\n  height: 18px;\n  flex: none;\n  margin-top: 1px;\n}\n\n.note b {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n\n.note--info { background: var(--info-soft); color: var(--info); border-color: #cfe0f7; }\n.note--ok { background: var(--ok-soft); color: var(--ok); border-color: #c9ecd4; }\n.note--warn { background: var(--warn-soft); color: var(--warn); border-color: #f8dcc2; }\n.note--err { background: var(--err-soft); color: var(--err); border-color: #f6cfcb; }\n.note--mute { background: var(--surface-2); color: var(--ink-2); border-color: var(--line-2); }\n\n/* ── 빈 상태 ───────────────────────────────────────── */\n.empty {\n  text-align: center;\n  padding: 56px 20px;\n  color: var(--ink-3);\n}\n\n.empty .art {\n  width: 120px;\n  height: 100px;\n  margin: 0 auto 14px;\n}\n\n.empty h4 {\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.empty p {\n  margin-top: 6px;\n  font-size: 14px;\n  max-width: 40ch;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.empty .btn {\n  margin-top: 18px;\n}\n\n/* ── 오류 상태 ─────────────────────────────────────── */\n.error-state {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 18px 20px;\n  border: 1px solid #f6cfcb;\n  border-radius: var(--r-2);\n  background: var(--err-soft);\n  color: var(--err);\n}\n\n.error-state svg {\n  flex: none;\n}\n\n.error-state b {\n  display: block;\n  font-weight: 600;\n  color: var(--err);\n}\n\n.error-state p {\n  font-size: 13px;\n  color: var(--ink-2);\n  margin-top: 2px;\n}\n\n.error-state .btn {\n  margin-left: auto;\n}\n\n/* ── 스켈레톤 ──────────────────────────────────────── */\n.skel {\n  background: linear-gradient(90deg, var(--surface-3) 25%, var(--sunk) 37%, var(--surface-3) 63%);\n  background-size: 400% 100%;\n  animation: skel 1.4s ease infinite;\n  border-radius: 6px;\n}\n\n@keyframes skel {\n  0% { background-position: 100% 50%; }\n  100% { background-position: 0 50%; }\n}\n\n/* ── 페이지네이션 ──────────────────────────────────── */\n.pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-top: 18px;\n}\n\n.pager .info {\n  font-size: 13px;\n  color: var(--ink-3);\n}\n\n.pager .pages {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.pager .pages button {\n  min-width: 34px;\n  height: 34px;\n  padding: 0 8px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ink-2);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--dur);\n}\n\n.pager .pages button:hover:not(:disabled) {\n  background: var(--surface-3);\n  color: var(--ink);\n}\n\n.pager .pages button.is-on {\n  background: var(--ink);\n  color: #fff;\n}\n\n.pager .pages button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.pager .pages button svg {\n  width: 15px;\n  height: 15px;\n}\n\n/* ── 모달 ───────────────────────────────────────────── */\n.modal-bg {\n  position: fixed;\n  inset: 0;\n  background: rgba(12, 17, 24, 0.55);\n  backdrop-filter: blur(3px);\n  z-index: var(--z-modal);\n  display: grid;\n  place-items: center;\n  padding: 20px;\n  animation: fade 0.18s ease both;\n}\n\n.modal {\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 40px);\n  background: var(--surface);\n  border-radius: var(--r-3);\n  box-shadow: var(--sh-3);\n  display: flex;\n  flex-direction: column;\n  animation: rise 0.28s var(--ease-out) both;\n  overflow: hidden;\n}\n\n.modal--lg {\n  max-width: 860px;\n}\n\n.modal--sm {\n  max-width: 440px;\n}\n\n.modal-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 22px 24px 16px;\n  border-bottom: 1px solid var(--line-2);\n}\n\n.modal-head h3 {\n  font-size: 19px;\n  font-weight: 700;\n}\n\n.modal-head p {\n  color: var(--ink-3);\n  font-size: 13.5px;\n  margin-top: 3px;\n}\n\n.modal-body {\n  padding: 20px 24px;\n  overflow-y: auto;\n}\n\n.modal-foot {\n  padding: 14px 24px 20px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  border-top: 1px solid var(--line-2);\n  background: var(--surface-2);\n}\n\n/* ── 토스트 ────────────────────────────────────────── */\n.toasts {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: var(--z-toast);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  pointer-events: none;\n}\n\n.toast {\n  pointer-events: auto;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 280px;\n  max-width: 380px;\n  padding: 12px 14px;\n  border-radius: var(--r-2);\n  background: var(--ink);\n  color: #fff;\n  box-shadow: var(--sh-3);\n  font-size: 13.5px;\n  line-height: 1.45;\n  animation: rise 0.28s var(--ease-out) both;\n}\n\n.toast svg {\n  width: 18px;\n  height: 18px;\n  flex: none;\n  margin-top: 1px;\n}\n\n.toast--ok svg { color: #5ee08a; }\n.toast--err svg { color: #ff8a80; }\n.toast--info svg { color: #8fb3ff; }\n\n.toast b {\n  display: block;\n  font-weight: 600;\n}\n\n.toast .x {\n  margin-left: auto;\n  color: rgba(255, 255, 255, 0.6);\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  display: grid;\n  place-items: center;\n}\n\n.toast .x:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n@media (max-width: 640px) {\n  .toasts {\n    left: 12px;\n    right: 12px;\n    bottom: 12px;\n  }\n  .toast {\n    min-width: 0;\n    max-width: none;\n  }\n}\n\n/* ── 타임라인 (주문 상태) ───────────────────────────── */\n.timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.timeline .tl {\n  display: grid;\n  grid-template-columns: 22px 1fr;\n  gap: 12px;\n  position: relative;\n  padding-bottom: 18px;\n}\n\n.timeline .tl:last-child {\n  padding-bottom: 0;\n}\n\n.timeline .tl::before {\n  content: \"\";\n  position: absolute;\n  left: 10px;\n  top: 20px;\n  bottom: -2px;\n  width: 2px;\n  background: var(--line);\n}\n\n.timeline .tl:last-child::before {\n  display: none;\n}\n\n.timeline .tl .pt {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 2px solid var(--line-strong);\n  background: var(--surface);\n  display: grid;\n  place-items: center;\n  z-index: 1;\n}\n\n.timeline .tl .pt svg {\n  width: 11px;\n  height: 11px;\n  color: #fff;\n}\n\n.timeline .tl.is-done .pt {\n  background: var(--ok);\n  border-color: var(--ok);\n}\n\n.timeline .tl.is-now .pt {\n  background: var(--brand);\n  border-color: var(--brand);\n  box-shadow: 0 0 0 4px var(--brand-soft);\n}\n\n.timeline .tl.is-done::before {\n  background: var(--ok);\n}\n\n.timeline .tl .t {\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--ink);\n}\n\n.timeline .tl .d {\n  font-size: 12.5px;\n  color: var(--ink-3);\n  margin-top: 2px;\n}\n\n.timeline .tl:not(.is-done):not(.is-now) .t {\n  color: var(--ink-3);\n}\n\n/* ── 정의 리스트 (키/값) ────────────────────────────── */\n.kv {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 10px 16px;\n  font-size: 14px;\n}\n\n.kv dt {\n  color: var(--ink-3);\n  font-size: 13px;\n}\n\n.kv dd {\n  margin: 0;\n  color: var(--ink);\n  font-weight: 500;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 480px) {\n  .kv {\n    grid-template-columns: 1fr;\n    gap: 2px 0;\n  }\n  .kv dd {\n    margin-bottom: 8px;\n  }\n}\n\n/* ── 구분선 ────────────────────────────────────────── */\n.hr {\n  height: 1px;\n  background: var(--line-2);\n  border: 0;\n  margin: 20px 0;\n}\n\n/* ── 아바타 ────────────────────────────────────────── */\n.avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--brand-soft);\n  color: var(--brand-deep);\n  font-family: var(--f-d);\n  font-weight: 800;\n  font-size: 14px;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  flex: none;\n  letter-spacing: 0;\n}\n\n.avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar--lg {\n  width: 64px;\n  height: 64px;\n  font-size: 22px;\n}\n\n/* ── antd 오버라이드 (작업 화면 전용) ──────────────── */\n.ant-btn-primary {\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
